import { Modal, Text } from "@mantine/core";
import React from "react";

interface ArchiveModalProps {
  opened: boolean;
  onClose: () => void;
  clientName?: string;
}

/**
 * A reusable modal component that displays a message about archived clients
 * Used to inform users that archived client profiles are not viewable
 */
const ArchiveModal: React.FC<ArchiveModalProps> = ({
  opened,
  onClose,
  clientName,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={700}>Archived Client Notice</Text>}
      withCloseButton
      centered
      padding="md"
    >
      <Text size="md">
        {clientName
          ? `${clientName}'s profile`
          : "Client profiles of archived clients"}{" "}
        {!clientName && "are"}
        <Text span fw={700} inherit>
          {clientName ? "is" : ""} not viewable
        </Text>{" "}
        because {clientName ? "they are" : "they're"} archived. To view the
        client's profile, please update the client's status from '
        <Text span fw={700} inherit>
          Archived
        </Text>
        ' to a different status.
      </Text>
    </Modal>
  );
};

export default ArchiveModal;
